import { registerSingleton } from '@/infrastructure/container';

import { AccountApi, TOKEN_IAccountApi } from '@/services/AccountApi';
import { Qr, TOKEN_IQr } from '@/services/Qr';
import { TOKEN_IWebauthnCeremony, WebauthnCeremony } from '@/services/WebauthnCeremony';
import { AdminApi, TOKEN_IAdminApi } from '@/services/AdminApi';
import { AppBus, TOKEN_IAppBus } from '@/services/AppBus';
import { AuthService, TOKEN_IAuth } from '@/services/AuthService';
import { Clock, TOKEN_IClock } from '@/services/Clock';
import { DomKeyboard, TOKEN_IDomKeyboard } from '@/services/DomKeyboard';
import { DomNavigation, TOKEN_IDomNavigation } from '@/services/DomNavigation';
import { DomTheme, TOKEN_IDomTheme } from '@/services/DomTheme';
import { IdGen, TOKEN_IIdGen } from '@/services/IdGen';
import { LocalStorage, TOKEN_ILocalStorage } from '@/services/LocalStorage';
import { Logger, TOKEN_ILogger } from '@/services/Logger';

import { AppStore, TOKEN_AppStore } from '@/views/AppStore';
import { AuthStore, TOKEN_AuthStore } from '@/views/AuthStore';
import { NavStore, TOKEN_NavStore } from '@/views/NavStore';
import { ThemeStore, TOKEN_ThemeStore } from '@/views/ThemeStore';
import { ToastStore, TOKEN_ToastStore } from '@/views/ToastStore';
import { AccountStore, TOKEN_AccountStore } from '@/views/account/AccountStore';
import { MfaStore, TOKEN_MfaStore } from '@/views/account/MfaStore';
import { ClientsStore, TOKEN_ClientsStore } from '@/views/admin/ClientsStore';
import { EventsStore, TOKEN_EventsStore } from '@/views/admin/EventsStore';
import { UsersStore, TOKEN_UsersStore } from '@/views/admin/UsersStore';

// The ONLY place register* is called. The dependency graph is visible here.
export function ud_di(): void {
  registerSingleton(TOKEN_ILogger, () => new Logger());
  registerSingleton(TOKEN_IAppBus, (r) => new AppBus(r(TOKEN_ILogger)));
  registerSingleton(TOKEN_IClock, () => new Clock());
  registerSingleton(TOKEN_IIdGen, () => new IdGen());
  registerSingleton(TOKEN_ILocalStorage, () => new LocalStorage());
  registerSingleton(TOKEN_IDomTheme, () => new DomTheme());
  registerSingleton(TOKEN_IDomNavigation, (r) => new DomNavigation(r(TOKEN_IAppBus), r(TOKEN_ILogger)));
  registerSingleton(TOKEN_IDomKeyboard, (r) => new DomKeyboard(r(TOKEN_IAppBus)));
  registerSingleton(TOKEN_IAuth, () => new AuthService());
  registerSingleton(TOKEN_IAdminApi, (r) => new AdminApi(r(TOKEN_IAuth)));
  registerSingleton(TOKEN_IAccountApi, (r) => new AccountApi(r(TOKEN_IAuth)));
  registerSingleton(TOKEN_IQr, () => new Qr());
  registerSingleton(TOKEN_IWebauthnCeremony, () => new WebauthnCeremony());

  registerSingleton(TOKEN_AppStore, (r) => new AppStore(r(TOKEN_IDomNavigation), r(TOKEN_IDomKeyboard)));
  registerSingleton(TOKEN_ThemeStore, (r) => new ThemeStore(r(TOKEN_IAppBus), r(TOKEN_ILocalStorage), r(TOKEN_IDomTheme)));
  registerSingleton(TOKEN_ToastStore, (r) => new ToastStore(r(TOKEN_IAppBus), r(TOKEN_IIdGen)));
  registerSingleton(TOKEN_AuthStore, (r) => new AuthStore(r(TOKEN_IAuth), r(TOKEN_ILogger)));
  registerSingleton(TOKEN_NavStore, () => new NavStore());
  registerSingleton(TOKEN_UsersStore, (r) => new UsersStore(r(TOKEN_IAdminApi), r(TOKEN_ILogger)));
  registerSingleton(TOKEN_ClientsStore, (r) => new ClientsStore(r(TOKEN_IAdminApi), r(TOKEN_ILogger)));
  registerSingleton(TOKEN_EventsStore, (r) => new EventsStore(r(TOKEN_IAdminApi), r(TOKEN_ILogger)));
  registerSingleton(TOKEN_AccountStore, (r) => new AccountStore(r(TOKEN_IAccountApi), r(TOKEN_ILogger)));
  registerSingleton(TOKEN_MfaStore, (r) => new MfaStore(r(TOKEN_IAccountApi), r(TOKEN_IWebauthnCeremony), r(TOKEN_IQr), r(TOKEN_ILogger)));
}
